import { PartsFilters } from "./inventoryTypes";

export const itemValidator = (item: any) => {
  if (!item.partName) return false;
  return true;
};

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: PartsFilters
) => {
  return true;
};
